// Controle da instalação como app (PWA). O evento beforeinstallprompt é capturado
// no carregamento (index.js) para poder oferecer a instalação a qualquer momento.
let eventoInstalacao = null;
const ouvintes = new Set();

const notificar = () => ouvintes.forEach((fn) => fn());

export function iniciarPwa() {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    eventoInstalacao = event;
    notificar();
  });
  window.addEventListener('appinstalled', () => {
    eventoInstalacao = null;
    localStorage.setItem('rfc_app_instalado', '1');
    notificar();
  });
  if ('serviceWorker' in navigator && (window.location.protocol === 'https:' || window.location.hostname === 'localhost')) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
  }
}

export const assinar = (fn) => {
  ouvintes.add(fn);
  return () => ouvintes.delete(fn);
};

export const rodandoComoApp = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const ehIOS = () => /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export const ehCelular = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || ehIOS();

// Chrome/Edge/Android: há prompt nativo. iOS: instalação manual pelo menu Compartilhar.
export const podeInstalar = () => !rodandoComoApp() && (Boolean(eventoInstalacao) || ehIOS());

export async function instalar() {
  if (!eventoInstalacao) return 'manual';
  eventoInstalacao.prompt();
  const { outcome } = await eventoInstalacao.userChoice;
  eventoInstalacao = null;
  notificar();
  return outcome; // 'accepted' | 'dismissed'
}
